var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendOrderSolid = function SvgSendOrderSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 19a.747.747 0 0 1-.22.53l-2 2a.75.75 0 0 1-1.06 0l-1.566-1.565-2.488 1.659A.75.75 0 0 1 3.25 21V5A2.75 2.75 0 0 1 6 2.25h10A2.75 2.75 0 0 1 18.75 5v8a.75.75 0 0 1-.75.75 2.25 2.25 0 0 0-2.122 3H14A2.25 2.25 0 0 0 11.75 19ZM7.25 7A.75.75 0 0 1 8 6.25h6a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 7Zm0 4a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75Zm0 4a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.47 15.47a.75.75 0 0 0 0 1.06l1.72 1.72H14a.75.75 0 0 0 0 1.5h5.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0Z",
    fill: "currentColor"
  })));
};
export default SvgSendOrderSolid;